import type {RentalResourceCalendarEvent} from '../types/RentalResourceCalendarEvent';

/**
 * Filters events to only include those that overlap with the specified month
 *
 * @param events - Array of events to filter
 * @param currentDate - Date representing the month to filter by
 * @returns Array of events that overlap with the specified month
 */
export function filterEventsForMonth(
  events: RentalResourceCalendarEvent[],
  currentDate: Date
): RentalResourceCalendarEvent[] {
  const monthStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const monthEnd = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0,
    23,
    59,
    59,
    999
  );

  return events.filter(
    (event) =>
      // Event overlaps with month if:
      // Event starts before month ends AND event ends after month starts
      event.start <= monthEnd && event.end >= monthStart
  );
}
